import { render } from "./PaymentsGetReceipt.vue?vue&type=template&id=567416c2"
import script from "./PaymentsGetReceipt.vue?vue&type=script&lang=js"
export * from "./PaymentsGetReceipt.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__